// src/pages/bestratesonly/BestRatesOnly.jsx
import React, { useState } from "react";
import GiftCardRateTable from "../../components/giftcardratesTable/GiftCardRateTable";
import GCLogo from "../../assets/GC_logo.svg"; // replace if your logo path is different

const BestRatesOnly = () => {
  // Mock data for demonstration
  const mockList = [
    {
      currency: "USD",
      list: [
        { name: "10", rate: 900 },
        { name: "20", rate: 1800 },
        { name: "50", rate: 4500 },
      ],
    },
    {
      currency: "EUR",
      list: [
        { name: "10", rate: 950 },
        { name: "20", rate: 1900 },
        { name: "50", rate: 4750 },
      ],
    },
    {
      currency: "GBP",
      list: [
        { name: "10", rate: 800 },
        { name: "20", rate: 1600 },
        { name: "50", rate: 4000 },
      ],
    },
  ];

  return (
    <div style={{ padding: "20px", maxWidth: "1200px", margin: "0 auto" }}>
      <h2 className="mb-4 text-center">Giftcard Rates & Calculator</h2>
      <GiftCardRateTable
        logo={GCLogo}
        cardName="Sample Gift Card"
        list={mockList} // Pass mock data
      />
    </div>
  );
};

export default BestRatesOnly;
